import {
  CANCEL_SUBSCRIPTION, CANCEL_SUBSCRIPTION_FAILED, CANCEL_SUBSCRIPTION_SUCCESSFULLY, ERROR_ON_GETTING_INVOICE_LIST,
  ERROR_ON_GETTING_SUBSCRIPTION_LIST, INTERVAL_CHOSEN, RECEIVED_INVOICE_LIST, RECEIVED_SUBSCRIPTION_LIST,
  START_FETCHING_INVOICE_LIST,
  START_FETCHING_SUBSCRIPTION_LIST, TIER_CHOSEN,
  START_FETCHING_EMAIL_SUBSCRIBE_STATUS,
  RECEIVED_EMAIL_SUBSCRIBE_STATUS,
  START_TOGGLE_PRINT_STATUS_EMAIL,
  TOGGLE_PRINT_STATUS_EMAIL_SUCCESSFULLY,
  TOGGLE_PRINT_STATUS_EMAIL_FAILED
} from "../actions/types";
import {INTERVAL_NAMES_SUFFIX, TIER_RANKS_PREFIX} from "../containers/subscription-container";
import { EMAIL_SUBSCRIBE_STATUS } from "../containers/account-setting-container";

const initState = {
  loadingSubscriptionList: true,
  subscriptionList: [],
  chosenTierRank: TIER_RANKS_PREFIX.TIER0,
  chosenInterval: INTERVAL_NAMES_SUFFIX.MONTHLY,
  planFullName: TIER_RANKS_PREFIX.TIER0,
  subscribedTierRank: TIER_RANKS_PREFIX.TIER0,
  subscribedInterval: null,
  subscribedPlanFullName: null,
  hasSubscription: false,
  loadingInvoiceList: true,
  invoiceList: [],
  emailSubscribeStatus: EMAIL_SUBSCRIBE_STATUS.ON,
  emailSubscribeToggleable: true
}

const SubscriptionReducer = (state = initState, action) => {
  const { type, payload } = action;
  let intervalName = state.chosenInterval;
  let tierName = state.chosenTierRank;
  let planFullName = null;
  switch (type) {
    case START_FETCHING_EMAIL_SUBSCRIBE_STATUS:
      return { ...state, emailSubscribeToggleable: false };
    case RECEIVED_EMAIL_SUBSCRIBE_STATUS:
      return { ...state, emailSubscribeToggleable: true, emailSubscribeStatus: payload.emailSubscribeStatus }
    case START_TOGGLE_PRINT_STATUS_EMAIL:
      return { ...state, emailSubscribeToggleable: false };
    case TOGGLE_PRINT_STATUS_EMAIL_SUCCESSFULLY:
      return { ...state, emailSubscribeToggleable: true, emailSubscribeStatus: payload.emailSubscribeStatus};
    case TOGGLE_PRINT_STATUS_EMAIL_FAILED:
      return { ...state, emailSubscribeToggleable: true};
    case START_FETCHING_SUBSCRIPTION_LIST:
      return { ...state, loadingSubscriptionList: true };
    case RECEIVED_SUBSCRIPTION_LIST:
      return updateSubscriptionStatus(state, payload);
    case ERROR_ON_GETTING_SUBSCRIPTION_LIST:
      return { ...state, error: payload.error, loadingSubscriptionList: false }
    case INTERVAL_CHOSEN:
      intervalName = payload.chosenInterval;
      if (intervalName && tierName) {
        planFullName = `${tierName}_${intervalName}`;
      }
      return { ...state, chosenInterval: intervalName, planFullName }
    case TIER_CHOSEN:
      tierName = payload.chosenTierRank;
      if (tierName === TIER_RANKS_PREFIX.TIER0) {
        planFullName = tierName;
      }
      else if (intervalName && tierName) {
        planFullName = `${tierName}_${intervalName}`
      }
      return { ...state, chosenTierRank: tierName, planFullName }
    case CANCEL_SUBSCRIPTION:
    case CANCEL_SUBSCRIPTION_SUCCESSFULLY:
    case CANCEL_SUBSCRIPTION_FAILED:
      return state;
    case START_FETCHING_INVOICE_LIST:
      return { ...state, loadingInvoiceList: true }
    case RECEIVED_INVOICE_LIST:
      const { invoiceList } = payload;
      return { ...state, loadingInvoiceList: false, invoiceList }
    case ERROR_ON_GETTING_INVOICE_LIST:
      return { ...state, loadingInvoiceList: false, error: payload.error, }
    default:
      return state;
  }
}


function updateSubscriptionStatus(state, payload) {
  const { subscriptionList } = payload;
  if (!subscriptionList || subscriptionList.length === 0 || !subscriptionList[0].id) {
    return {
      ...state,
      subscriptionList: [],
      loadingSubscriptionList: false,
      hasSubscription: false,
      subscribedTierRank: TIER_RANKS_PREFIX.TIER0
    }
  }
  const planList = ["TIER0_MONTHLY", "TIER1_MONTHLY", "TIER2_MONTHLY", "TIER1_YEARLY", "TIER2_YEARLY"];
  const subscriptionPlanList = subscriptionList.filter(subscription => {
      return subscription.plan.nickname && planList.includes(subscription.plan.nickname);
  });

  const subscribedPlanFullName = subscriptionPlanList && subscriptionPlanList.length ? subscriptionPlanList[0].plan.nickname : "TIER0_MONTHLY";
  const delimiterIndex = subscribedPlanFullName.indexOf('_');
  const subscribedTierRank = subscribedPlanFullName.substring(0, delimiterIndex);
  const subscribedInterval = subscribedPlanFullName.substring(delimiterIndex + 1);
  return {
    ...state,
    subscriptionList,
    subscribedTierRank,
    subscribedInterval,
    subscribedPlanFullName,
    chosenTierRank: subscribedTierRank,
    chosenInterval: subscribedInterval,
    planFullName: subscribedPlanFullName,
    loadingSubscriptionList: false,
    hasSubscription: true
  }
}

export default SubscriptionReducer;


// WEBPACK FOOTER //
// ./src/reducers/subscription-reducer.js